module.exports = __webpack_public_path__ + "static/media/dark-submenu-grupos.7b920acc.svg";